import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { FaQuoteLeft } from "react-icons/fa";
import presidentimg from "../assets/Img/airaa-president-dev-mohanty.webp";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PresidentMessage = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="relative bg-gradient-to-br from-blue-950 via-blue-900 to-green-900 rounded-3xl overflow-hidden shadow-2xl"
    >
      {/* Blobs */}
      <div className="absolute top-0 right-0 w-48 h-48 rounded-full bg-emerald-400/10 blur-3xl animate-float pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-40 h-40 rounded-full bg-blue-300/10 blur-3xl animate-float-alt pointer-events-none" />

      <div className="relative flex flex-col md:flex-row items-center gap-8 p-8 md:p-10">
        {/* Photo */}
        <div className="shrink-0 flex flex-col items-center">
          <div className="w-32 h-32 md:w-44 md:h-44 rounded-full overflow-hidden ring-4 ring-emerald-400/60 ring-offset-4 ring-offset-blue-900 shadow-2xl">
            <img src={presidentimg} alt="President" className="w-full h-full object-cover object-top" />
          </div>
          <div className="mt-3 text-center">
            <p className="text-white font-bold text-sm">Dr. Dev Mohanty</p>
            <p className="text-emerald-300 text-xs mt-0.5">Chairman & President, AIRAA</p>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 text-center md:text-left">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-emerald-300 mb-3">
            Leadership Message
          </span>
          <h2 className="text-2xl md:text-3xl font-extrabold text-white leading-tight mb-5">
            {t("presidentMessageTitle")}
          </h2>
          <div className="relative pl-4 ">
            <FaQuoteLeft className="absolute -left-3 -top-1 text-emerald-400 text-xl opacity-60" />
            <p className="text-blue-100 text-sm md:text-base leading-relaxed italic line-clamp-4">
              <span className="font-semibold text-emerald-300">AIRAA</span> {t("presidentMessage")}
            </p>
          </div>
          <Link
            to="/presidentmessage"
            className="inline-flex items-center gap-2 mt-6 text-emerald-300 hover:text-white text-sm font-semibold transition-colors"
          >
            Read Full Message <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default PresidentMessage;
